import { Container, Box, Typography, useTheme } from '@mui/material';
import WorldMapBackground from '../../assets/background-images/globe-svg.svg';

const WelcomeMessage = () => {
  const theme = useTheme();
  return (
    <Container
      sx={{
        padding: {
          xs: `${theme.spacingValues.large} ${theme.spacingValues.small}`,
          md: `${theme.spacingValues.extralarge} ${theme.spacingValues.small}`,
        },

        paddingBottom: 0,
        maxWidth: '1064px',
        backgroundImage: {
          xs: `url(${WorldMapBackground})`,
          md: 'none',
        },
        backgroundSize: {
          xs: '200%',
          sm: '200%',
        },
        backgroundPosition: {
          xs: 'center center',
          sm: 'center center',
        },
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: {
              xs: '2rem',
              md: '4rem',
            },
            fontWeight: 'bolder',
          }}
        >
          <span style={{ color: theme.palette.primary.main }}>
            Viaje com tranquilidade!
          </span>
          <Box
            component="span"
            sx={{
              display: { xs: 'block', sm: 'inline' },
              ml: { xs: 0, sm: '0.25em' },
            }}
          >
            <span style={{ color: theme.palette.text.primary }}>
              Compare e encontre o melhor seguro viagem.
            </span>
          </Box>
        </Typography>
        <Typography
          sx={{
            maxWidth: '604px',
            fontSize: {
              xs: '1rem',
              md: theme.typography.h4.fontSize,
            },
          }}
        >
          Não perca tempo. Compare as melhores seguradoras, coberturas e preços,
          tudo em um só lugar!
        </Typography>
      </Box>
    </Container>
  );
};

export default WelcomeMessage;
